module.exports = __webpack_public_path__ + "img/camera-movie.deb70a2d.svg";